import { useEffect, useRef } from "react"

import { setPluginsDateHelpers } from "@/helpers/date.helpers"
import { useResizeObserver } from "@/hooks/useResizeObserver"

const measure = (entities: ResizeObserverEntry[]) => {
  const el = entities?.[0]?.target as HTMLDivElement

  if (!el) return

  const previousSBW = el.getAttribute("data-sbw") || ""
  const nextSBW = `${el.offsetWidth - el.clientWidth}px`

  if (previousSBW === nextSBW) return

  document.documentElement.style.setProperty("--sbw", nextSBW)
  el.setAttribute("data-sbw", nextSBW)
}

export const useInitApp = () => {
  const ref = useRef<HTMLDivElement | null>(null)

  if (!ref.current)
    ref.current = document.getElementById("measure") as HTMLDivElement

  useEffect(() => {
    setPluginsDateHelpers()
  }, [])

  useResizeObserver(ref, measure)
}
